import type { ImgHTMLAttributes } from 'react';

type ResponsiveImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  aspectRatio?: string;
};

export function ResponsiveImage({
  alt,
  aspectRatio = '5 / 4',
  className = '',
  loading = 'lazy',
  ...props
}: ResponsiveImageProps) {
  return (
    <img
      alt={alt}
      className={`responsive-image ${className}`.trim()}
      loading={loading}
      style={{ aspectRatio }}
      {...props}
    />
  );
}
